import React from "react";
import CodeIcon from "@mui/icons-material/Code";
import StorageIcon from "@mui/icons-material/Storage";
import StorefrontIcon from "@mui/icons-material/Storefront";
import ConstructionIcon from "@mui/icons-material/Construction";
import ViewDayIcon from "@mui/icons-material/ViewDay";

export const All = [
  {
    logo: require("../../static/images/azure.png"),
    heading: "Azure",
  },
  {
    logo: require("../../static/images/awscloud.png"),
    heading: "AWS",
  },
  {
    logo: require("../../static/images/django.png"),
    heading: "Django",
  },
  {
    logo: require("../../static/images/mongodb.png"),
    heading: "MongoDB",
  },
  {
    logo: require("../../static/images/Oracle_Logo.png"),
    heading: "ORACLE",
  },

  {
    logo: require("../../static/images/flutter.webp"),
    heading: "Flutter",
  },

  {
    logo: require("../../static/images/java.png"),
    heading: "Java",
  },
  {
    logo: require("../../static/images/nuxtjs.png"),
    heading: "Nuxt JS",
  },
  {
    logo: require("../../static/images/ruby.jpg"),
    heading: "Ruby On Rails",
  },
  {
    logo: require("../../static/images/python.png"),
    heading: "Python",
  },
  {
    logo: require("../../static/images/android.png"),
    heading: "Android",
  },
];

export const gridHome = [
  {
    logo: <CodeIcon />,
    heading: "Coding Languages",
    description:
      "Python, Ruby, GoLang, Node, C#, Asp.Net, Java, PHP, Javascript, iOS, Android, HTML, HTML 5, TypeScript, JQuery, CSS / CSS3, C / C++",
  },
  {
    logo: <StorageIcon />,
    heading: "Database",
    description:
      "MySql / MariaDB, PostgreSQL, Cassandra, SqLite3, MongoDB, DynamoDB, Oracle 9i, Microsoft SQL Server, GraphQL",
  },
  {
    logo: <StorefrontIcon />,
    heading: "Caches & VK Stores",
    description: "Redis, Mem-cache",
  },
  {
    logo: <ConstructionIcon />,
    heading: "Coding Languages",
    description:
      "Python, Ruby, GoLang, Node, C#, Asp.Net, Java, PHP, Javascript, iOS, Android, HTML, HTML 5, TypeScript, JQuery, CSS / CSS3, C / C++",
  },
  {
    logo: <StorefrontIcon />,
    heading: "Tools",
    description:
      "Microsoft Visual Studio, PyScharm, Go-land, Data-Grip, Eclipse IDE, Net Bean IDE, Php Storm, MATLAB, Sublime, Atom",
  },
  {
    logo: <ViewDayIcon />,
    heading: "Frontend Frameworks",
    description: "ReactJS, Next.js, Nuxt.js, VueJS, AngularJS, BackboneJS",
  },
];

export const FrontendDevelopmentIcons = [
  {
    logo: require("../../static/images/angular.webp"),
    heading: "Angular",
  },
  {
    logo: require("../../static/images/nextjs.png"),
    heading: "Next Js",
  },
  {
    logo: require("../../static/images/react.png"),
    heading: "React",
  },
  {
    logo: require("../../static/images/vue.png"),
    heading: "Vue",
  },
  {
    logo: require("../../static/images/html.webp"),
    heading: "HTML",
  },
  {
    logo: require("../../static/images/bootstrap.png"),
    heading: "Bootstrap",
  },
  {
    logo: require("../../static/images/javascript.png"),
    heading: "Javascript",
  },
  {
    logo: require("../../static/images/react-native.png"),
    heading: "React Native",
  },
];

export const BackendDevelopmentIcons = [
  {
    logo: require("../../static/images/python.png"),
    heading: "Python",
  },
  {
    logo: require("../../static/images/azure.png"),
    heading: "Azure",
  },
  {
    logo: require("../../static/images/awscloud.png"),
    heading: "AWS",
  },
  {
    logo: require("../../static/images/django.png"),
    heading: "Django",
  },
  {
    logo: require("../../static/images/mongodb.png"),
    heading: "MongoDB",
  },
  {
    logo: require("../../static/images/ruby.jpg"),
    heading: "Ruby On Rails",
  },
  {
    logo: require("../../static/images/php.png"),
    heading: "PHP",
  },
  {
    logo: require("../../static/images/java.png"),
    heading: "Java",
  },
  {
    logo: require("../../static/images/c.png"),
    heading: "C#",
  },
];

export const MobileAppDevelopmentIcons = [
  {
    logo: require("../../static/images/java.png"),
    heading: "Java",
  },
  {
    logo: require("../../static/images/c.png"),
    heading: "C#",
  },
  {
    logo: require("../../static/images/react-native.png"),
    heading: "React Native",
  },
  {
    logo: require("../../static/images/javascript.png"),
    heading: "Javascript",
  },
  {
    logo: require("../../static/images/python.png"),
    heading: "Python",
  },
  {
    logo: require("../../static/images/flutter.webp"),
    heading: "Flutter",
  },
  {
    logo: require("../../static/images/rust.png"),
    heading: "Rust",
  },
];

export const MicroservicesIcons = [
  {
    logo: require("../../static/images/python.png"),
    heading: "Python",
  },
  {
    logo: require("../../static/images/java.png"),
    heading: "Java",
  },
  {
    logo: require("../../static/images/c.png"),
    heading: "C#",
  },
  {
    logo: require("../../static/images/javascript.png"),
    heading: "Javascript",
  },
  {
    logo: require("../../static/images/django.png"),
    heading: "Django",
  },
  {
    logo: require("../../static/images/docker.png"),
    heading: "Docker",
  },
  {
    logo: require("../../static/images/relationaldb.jfif"),
    heading: "Relational Database",
  },
  {
    logo: require("../../static/images/jwt.png"),
    heading: "JWT",
  },
];

export const HybridAppIcons = [
  {
    logo: require("../../static/images/flutter.webp"),
    heading: "Flutter",
  },
  {
    logo: require("../../static/images/react-native.png"),
    heading: "React Native",
  },
  {
    logo: require("../../static/images/javascript.png"),
    heading: "Javascript",
  },
  {
    logo: require("../../static/images/html.webp"),
    heading: "HTML",
  },
  {
    logo: require("../../static/images/bootstrap.png"),
    heading: "Bootstrap",
  },
  {
    logo: require("../../static/images/angular.webp"),
    heading: "Angular",
  },
  {
    logo: require("../../static/images/nextjs.png"),
    heading: "Next Js",
  },
  {
    logo: require("../../static/images/react.png"),
    heading: "React",
  },
  {
    logo: require("../../static/images/c.png"),
    heading: "C#",
  },
];

export const InfrasructureIcons = [
  {
    logo: require("../../static/images/azure.png"),
    heading: "Azure",
  },
  {
    logo: require("../../static/images/awscloud.png"),
    heading: "AWS",
  },
  {
    logo: require("../../static/images/docker.png"),
    heading: "Docker",
  },
  {
    logo: require("../../static/images/relationaldb.jfif"),
    heading: "Relational Database",
  },
  {
    logo: require("../../static/images/kubernetes.png"),
    heading: "Kubernetes",
  },
  {
    logo: require("../../static/images/amazonS3.png"),
    heading: "Amazon S3",
  },
  {
    logo: require("../../static/images/gitlab.png"),
    heading: "Gitlab CI/CD",
  },
  {
    logo: require("../../static/images/AWSLambda.png"),
    heading: "AWS Lambda",
  },
];
